/* eslint-disable */
/* prettier-ignore */
// File provided by backend for encrypt/decrypt personal info. Combined with _infodecrypt.scss

const $ = require('jquery');

const infodecrypt = function() {
	$(document).ready(function() {
		$('.emailencrypt').each(function() {
			var r = $(this).attr('mailto');
			var m = atob(r);
			var e = m.replace('@', '@<span style="display:none;">spam-prevention</span>');
			if ($('span.contact-icon',this).length > 0) {
				e = '<span class="contact-icon"><i class="fas fa-envelope fa-lg"></i></span>';
			}
			$(this).html(e);
			$(this).removeAttr('mailto', '');
			$(this).attr('href', 'mailto:' + r);
			$(this).click(function() {
				location.href = 'mailto:' + m;
				return false;
			});
			$(this).show();
		});

		$('.phoneencrypt').each(function() {
			var r = $(this).attr('tel');
			var m = atob(r);
			var s = m.length / 2;
			var e = m.slice(0, s) + '<span style="display:none;">spam-prevention</span>' + m.slice(s);
			if ($('span.contact-icon',this).length > 0) {
				e = '<span class="contact-icon"><i class="fas fa-phone-alt has-margin-right-1 fa-lg"></i></span>';
			}
			$(this).html(e);
			$(this).removeAttr('tel');
			const $link = $(this).is('a') ? $(this) : $(this).closest('a');
			if($link) {
				$link.attr('href', 'tel:' + r);
				$link.click(function() {
					location.href = 'tel:' + m;
					return false;
				});	
			}
			$(this).show();
		});
	});
};

module.exports = {
	init: infodecrypt
};
